export const environment = {
    production: false,
    i18nVersion: '2026.04.24',
    authUrl: 'https://dev-auth-cc.simplified.com.co',
    clientId: 'calza-costa-ui',
    clientSecret: 'simplified',
    redirectUri: 'https://gestion-cc.simplified.com.co/callback',
    postLogoutRedirectUri: 'https://gestion-cc.simplified.com.co/',
    apiUrl: 'https://api-cc.simplified.com.co',
    scope: 'openid person:read person:write role:read role:write permission:read permission:write scope:read scope:write client:read client:write entities top100 users'
};
